
import { Reducer } from 'redux';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { AggregationState } from './types-store';
import { FieldItem } from 'app/area/reports/types';

export const INITIAL_STATE: AggregationState = {
  fetching: false,
  initialized: false,
  defaultAggregateFields: undefined,
  additionalAggregateFields: [],
  aggregateFunctionOptions: [],
  uomSetOptions: []
};

export const aggregationReducers: { [indexer: string]: Reducer<AggregationState> } = {
  
  [ACTION.CLEAR_AGGREGATION_STATE]: (state: AggregationState,
    action: actions.ClearAggregationState
  ): AggregationState => {
    return {
      ...state,
      ...INITIAL_STATE
    };
  },
  [ACTION.REQUEST_AGGREGATE_DEFAULT_FIELDS]: (state: AggregationState,
    action: actions.RequestAggregateDefaultFields
  ): AggregationState => {
    return {
      ...state,
      fetching: true
    };
  },
  [ACTION.RESPONSE_AGGREGATE_DEFAULT_FIELDS]: (state: AggregationState,
    action: actions.ResponseAggregateDefaultFields
  ): AggregationState => {
    return {
      ...state,
      fetching: false,
      initialized: true,
      defaultAggregateFields: action.options as FieldItem[]
    };
  },
  [ACTION.UPDATE_DEFAULT_AGGREGATE_FIELDS]: (state: AggregationState,
    action: actions.UpdateAggregateDefaultFields
  ): AggregationState => {
    return {
      ...state,
      defaultAggregateFields: action.options as FieldItem[]
    };
  },
  [ACTION.RESPONSE_AGGREGATE_FIELDS]: (state: AggregationState,
    action: actions.ResponseAggregateFields
  ): AggregationState => {
    return {
      ...state,
      additionalAggregateFields: action.options as FieldItem[]
    };
  },
  [ACTION.SET_OPTIONS]: (state: AggregationState,
    action: actions.SetOptions): AggregationState => {
      return {
        ...state,
        uomSetOptions: action.uomSetOptions,
        aggregateFunctionOptions: action.aggregateFunctionOptions
      };
    }
};

export const aggregationReducer = (state: AggregationState = INITIAL_STATE, action: any) => {
  const r = aggregationReducers[action.type];
  return (r && r(state, action)) || state;
};
